import React, { useState } from "react";
import Layout from "../../components/layout";
import SalesmateMainBanner from "../../components/salesmate-case-study/page-main-banner";
import SalesmateCsIntro from "../../components/salesmate-case-study/cs-intro";
import CsPlatformIntro from "../../components/salesmate-case-study/cs-platform-intro";
import SalesmateCsOurProduct from "../../components/salesmate-case-study/cs-ourProducts";
import CsServiceTabs from "../../components/salesmate-case-study/cs-tab-section";
import CsDesignSystem from "../../components/salesmate-case-study/cs-design-system";
import CsAPIPlatformIntro from "../../components/salesmate-case-study/cs-api-platform-intro";
import CsDevOps from "../../components/salesmate-case-study/cs-devops";
import CsEcosystem from "../../components/salesmate-case-study/cs-ecosystem";
import CsResult from "../../components/salesmate-case-study/cs-result";
import {
  serviceTabObj
} from '../../components/salesmate-case-study/salesmate-page-constants';
import SEO from '../../components/seo';
import FormSection from "../../components/common/templates/form/form-section";
import StickyCTA from "../../components/common/templates/sticky-cta-section";


function SalesmateCaseStudy({ location }) {
  const [isLoaded, setisLoaded] = useState(false);

  return (
    <div onLoad={() => setisLoaded(true)}>
      <Layout addBodyClass="salesmate-case-study-page-template white-header" footerFormType="basic">
        <SEO description="Rapidops, Inc developed customer CRM software on SaaS products including web application and native mobile applications for one of the biggest clients located in Charlotte, North Carolina, USA."
          meta={[{ name: "charSet", content: "utf-8" }]}
          title="SaaS CRM Software Development - Salesmate" />
        <SalesmateMainBanner isLoaded={isLoaded} />
        <SalesmateCsIntro />
        <CsPlatformIntro />
        <SalesmateCsOurProduct />
        <CsServiceTabs data={serviceTabObj} />
        <CsDesignSystem />
        <CsAPIPlatformIntro />
        <CsDevOps />
        <CsEcosystem />
        <CsResult />
        {/*<FormSection location={location} className="site-footer-form" />*/}
        {/* <StickyCTA /> */}
      </Layout>
    </div>
  );
}

export default SalesmateCaseStudy;
